import classNames from "classnames";

export const heading = classNames(
    // Mobile
    "mobile:flex",
    "mobile:flex-col",
    "mobile:px-12",
    "mobile:pb-2",
    // Tablet
    "tablet:px-44",
    "tablet:pt-4",
    "tablet:pb-4",
    // All
    "Raleway",
    "text-left",
    "text-base",
    "text-gray-500",
);
export const content = classNames(
    // Mobile
    "mobile:px-12",
    "mobile:pb-4",
    // Tablet
    "tablet:px-44",
    "tablet:pb-8",
    // All
    "text-left",
    "text-base",
    "text-gray-500"
);
export const link = classNames("text-primary", "cursor-pointer", "mobile:text-left");
